import { useGetAllAlertsMutation } from './features/authentication/authApiSlice';
import React from 'react';
import PropTypes from 'prop-types';

const globalContext = React.createContext();

export const GlobalProvider = ({ children }) => {
  const [getAllAlerts] = useGetAllAlertsMutation();
  const [allMessageGlobal, setAllMessage] = React.useState([]);

  const getAllMessage = async (options) => {
    try {
      const allMessages = await getAllAlerts(options).unwrap();
      setAllMessage(() => allMessages.data);
      return allMessages.total;
    } catch (ex) {
      if (!ex?.status) {
        console.log('No server response');
      } else {
        console.log('Login failed');
      }
    }
  };


  return (
    <globalContext.Provider
      value={{
        allMessageGlobal,
        getAllMessage
      }}>
      {children}
    </globalContext.Provider>
  );
};

GlobalProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const useGlobalContext = () => React.useContext(globalContext);
